@defer () {
  @if(finishedAuthCheck())
  {
    <router-outlet />
  }
}
@loading(after 100ms; minimum 2000s){
  <div alt='loading...' src="loading.gif"></div>
}
<app-loading />
<app-confirm-dialog />
<app-notificacion-dialog />
